import { Course } from './course';

export interface Training {
  totalTrainedDevelopers: number;
  courses: Course[];
  yearToDateSpend: {
    value: number;
    currencyCode: string;
  };
}
